import React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { toolbarOptionsTypes } from '../../utils/propTypes';
var selectionStyles = makeStyles(function (theme) {
  return {
    toolbar: {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.8),
      paddingRight: theme.spacing(1)
    },
    title: {
      width: '100%',
      maxWidth: '50%'
    },
    colorTitle: {
      color: theme.palette.secondary.main
    },
    actions: {
      width: '100%',
      textAlign: 'right',
      maxWidth: '50%'
    }
  };
});
var actionStyles = makeStyles(function (theme) {
  return {
    button: {
      color: theme.palette.text.secondary
    }
  };
});

var Action = function Action(_ref) {
  var action = _ref.action,
      selectedRows = _ref.selectedRows;
  var label = action.label,
      tooltip = action.tooltip,
      iconLeft = action.iconLeft,
      iconRight = action.iconRight,
      _onClick = action.onClick;
  var classes = actionStyles();
  var button = /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return _onClick(selectedRows);
    },
    className: classes.button
  }, iconLeft, label, iconRight);

  if (tooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltip
    }, button);
  }

  return button;
};

var SelectionActions = function SelectionActions(_ref2) {
  var options = _ref2.options,
      selectedRows = _ref2.selectedRows;

  var _ref3 = options || {},
      actions = _ref3.actions,
      selectedLabel = _ref3.selectedLabel;

  var classes = selectionStyles();
  return /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    id: "tableTitle",
    className: classes.colorTitle
  }, selectedLabel ? selectedLabel(selectedRows.length) : "".concat(selectedRows.length, " Selected"))), actions && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement(Action, {
      key: "tb-action-".concat(action.key),
      action: action,
      selectedRows: selectedRows
    });
  })));
};

SelectionActions.defaultProps = {
  selectedRows: [],
  options: null
};
SelectionActions.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  options: toolbarOptionsTypes
};
export default SelectionActions;